let products = [
  {
      title:"Apple Watch Series 8 GPS + Cellular 45mm Midnight Aluminium Case with Midnight Sport Band, Water resistant 50 metres, Dust resistant (IP6X), Fast charge, 3rd-gen optical heart sensor, Emergency SOS, Crash Detection, Fall Detection",
      images:["https://www.reliancedigital.in/medias/Apple-Series-8-Sports-Fitness-Watches-493177899-i-1-1200Wx1200H?context=bWFzdGVyfGltYWdlc3wxMDQxODZ8aW1hZ2UvanBlZ3xpbWFnZXMvaGE1L2hlNy85ODkxODg3NTEzNjMwLmpwZ3w5MDQwMDNiM2U0YWRmNDkyNWIyODI1NWM2ZWJhNDI4OTI0NTllY2E0MWNlOTdjOGNlYzNjMWQzZGIwMDViYWVi"],
      brand:"Apple",
      category:"Smartwatches",
      price:55366,
      mrp:58900,
      discount:6,
  },
  {
      title:"Apple Watch Series 8 GPS 41mm Midnight Aluminium Case with Midnight Sport Band, Water resistant 50 metres, Dust resistant (IP6X), Fast charge, 3rd-gen optical heart sensor, Emergency SOS, Crash Detection, Fall Detection",
      images:["https://www.reliancedigital.in/medias/Apple-Series-8-Sports-Fitness-Watches-493177911-i-1-1200Wx1200H?context=bWFzdGVyfGltYWdlc3wxMDE3NDJ8aW1hZ2UvanBlZ3xpbWFnZXMvaGI0L2gzNC85ODkxOTE1MzY2NDMwLmpwZ3wzNDk3MzIzODk0MTg1ZDk4ZjU1MWVlMDIyMGNjOGJmNzhiMjBmOTkwODkyMDU0YjNhYzg0MTE3YzhhNjI4ZDRl"],
      brand:"Apple",
      category:"Smartwatches",
      price:43146,
      mrp:45900,
      discount:6,
  },
  {
      title:"Apple Watch Ultra GPS + Cellular, 49mm Titanium Case with Midnight Ocean Band, Precision dual-frequency GNSS: GPS, GNSS, Galileo, BeiDou, 86-decibel Siren to attract attention, Altimeter, Accelerometer, Optical Heart Sensor, Gyroscope",
      images:["https://www.reliancedigital.in/medias/Apple-Ultra-Sports-Fitness-Watches-493177936-i-1-1200Wx1200H?context=bWFzdGVyfGltYWdlc3wxNTQ2MDJ8aW1hZ2UvanBlZ3xpbWFnZXMvaGY0L2hjNy85ODkxOTQzODc0NTkwLmpwZ3xmZWJjYTg2MWZlMTc3YjNjNWIzN2VjMzI0NWI0ZmYzYTRiMTk3ZTE1YzU3OWUxZjQ3ZTQ1MjYzY2NjYzI5Nzdh"],
      brand:"Apple",
      category:"Smartwatches",
      price:84506,
      mrp:89900,
      discount: 6,
  },
  {
      title:"Apple Watch Series 8 GPS 41mm Starlight Aluminium Case with Starlight Sport Band, Water resistant 50 metres, Dust resistant (IP6X), Fast charge, 3rd-gen optical heart sensor, Emergency SOS, Crash Detection, Fall Detection",
      images:["https://www.reliancedigital.in/medias/Apple-Series-8-Sports-Fitness-Watches-493177912-i-1-1200Wx1200H?context=bWFzdGVyfGltYWdlc3wxMDM2Mjd8aW1hZ2UvanBlZ3xpbWFnZXMvaGMxL2hlZi85ODkxOTE4OTcwOTEwLmpwZ3w0OTcxNDNkYWFiYTFhZmJmM2E5N2EzOTQyMjk3MjQ4OTE1N2VhZDg0NWE3NThhMDMxMTNiNzg2ZDI3OTJjNmY2"],
      brand:"Apple",
      category:"Smartwatches",
      price:43146,
      mrp:45900,
      discount:6,
  },
  {
      title:"Apple Watch Ultra GPS + Cellular, 49mm Titanium Case with Orange Alpine Loop - Medium, Precision dual-frequency GNSS: GPS, GNSS, Galileo, BeiDou, 86-decibel Siren to attract attention, Altimeter, Accelerometer, Optical Heart Sensor, Gyroscope",
      images:["https://www.reliancedigital.in/medias/Apple-Ultra-Sports-Fitness-Watches-493177937-i-1-1200Wx1200H?context=bWFzdGVyfGltYWdlc3wyNzkzNDB8aW1hZ2UvanBlZ3xpbWFnZXMvaDVkL2hkNS85ODkxOTQ0ODU3NjMwLmpwZ3xjYTAxNDEzNmY4ZjYyYTQ2ODY3YjA0MjEwMDU5ZTdiYjdkNmUzNmZlMzdhMjE0ZWU1M2M2NDEyMmZjOGUxNDhk"],
      brand:"Apple",
      category:"Smartwatches",
      price:84506,
      mrp:89900,
      discount:6,
  },
  {
      title:"Apple Watch SE (2nd Generation) GPS + Cellular 40mm Silver Aluminium Case with White Sport Band, 3rd Gen Optical Heart Sensor, Crash Detection, Fall Detection, 32 GB Capacity, 64-bit dual-core processor",
      images:["https://www.reliancedigital.in/medias/Apple-SE-Sports-Fitness-Watches-493177926-i-1-1200Wx1200H?context=bWFzdGVyfGltYWdlc3w3ODE3OXxpbWFnZS9qcGVnfGltYWdlcy9oYzEvaDg1Lzk4OTE5OTE3ODE0MDYuanBnfDIzMTkyZmFiN2I5YzIzODdiNTJiOTMyZjM3MTJhOGU5ZTNhZTQxODUyOWNkYWJmMzI1MTUwZWE2YmJiYTkwYmI"],
      brand:"Apple",
      category:"Smartwatches",
      price:32806,
      mrp:34900,
      discount:6,
  },
  {
      title:"Apple Watch Ultra GPS + Cellular, 49mm Titanium Case with Yellow/Beige Trail Loop - S/M, Precision dual-frequency GNSS: GPS, GNSS, Galileo, BeiDou, 86-decibel Siren to attract attention, Altimeter, Accelerometer, Optical Heart Sensor, Gyroscope",
      images:["https://www.reliancedigital.in/medias/Apple-Ultra-Sports-Fitness-Watches-493177934-i-1-1200Wx1200H?context=bWFzdGVyfGltYWdlc3wyMDc4NTh8aW1hZ2UvanBlZ3xpbWFnZXMvaGE2L2g3Ni85ODkxOTM3OTc2MzUwLmpwZ3wyMjg1ZDg5MGM5MmZhMjY1MTE4ODI1NDA1MDJjOWVkNmQ4NzJkZDM3YTMwYzk0YmViMTJhNDM1Y2FjNjRjZDg2"],
      brand:"Apple",
      category:"Smartwatches",
      price:84506,
      mrp:89900,
      discount:6,
  },
];

export default products;